import React, {useContext, useEffect, useState} from 'react'
import {DynamicComponentProps} from '../../core/_models'
import dayjs, {Dayjs} from 'dayjs'
import {DatePicker} from '@mui/x-date-pickers'

export function DateComponent({
  config: {id, title, value, onChange: action},
  context,
}: DynamicComponentProps) {
  const [v, setValue] = useState<Dayjs | null>(dayjs(value))
  const formContext = useContext(context)

  useEffect(() => {
    formContext.set(id, v!.format('DD-MM-YYYY'))
  }, [value])

  const handleChange = (newValue: Dayjs | null) => {
    if (!newValue?.isValid()) {
      return
    }

    setValue(newValue)
    formContext.set(id, newValue?.format('DD-MM-YYYY'))

    if (action != null) {
      formContext.submit({action})
    }
  }

  return (
    <DatePicker
      label={typeof title === 'object' ? title.text: title}
      value={v}
      onChange={handleChange}
      slotProps={{textField: {fullWidth: true, size: 'small'}}}
      openTo='day'
      views={['day', 'month', 'year']}
      format='DD-MM-YYYY'
    />
  )
  /*const [v, setValue] = useState(value);
  const formContext = useContext(context);

  useEffect(() => {
      formContext.set(id, v)
  }, [value])

  return (
      <>
          <TextField
              id="date-local"
              label={(typeof title === 'object' ? title.text : title)}
              type='date'
              value={dayjs(v).format('YYYY-MM-DD')}
              InputLabelProps={{
                  shrink: true,
              }}
              margin="none"
              size='small'
              fullWidth={true}
              onChange={(e) => {
                  const newValue = dayjs(e.target.value).format('YYYY-MM-DD')
                  setValue(e.target.value)
                  formContext.set(id, newValue)

                  if (onChange !== undefined && onChange !== null) {
                      formContext.submit({onChange})
                  }
              }}
          />
      </>)*/
}
